import type { ComponentProps, ReactNode } from 'react';
import { View } from 'react-native';

import { cn } from '@/lib/design-system/cn';
import { Text } from './Text';

export type CardProps = ComponentProps<typeof View> & {
  title?: string;
  description?: string;
  footer?: ReactNode;
};

export function Card({ title, description, footer, children, className, ...props }: CardProps) {
  return (
    <View className={cn('cs-card', className)} {...props}>
      {title || description ? (
        <View className="border-b border-border px-4 py-3">
          {title ? <Text variant="h3">{title}</Text> : null}
          {description ? <Text variant="caption" className="mt-1">{description}</Text> : null}
        </View>
      ) : null}
      <View className="px-4 py-4">{children}</View>
      {footer ? <View className="border-t border-border px-4 py-3">{footer}</View> : null}
    </View>
  );
}
